import type { LoginResponseModel } from "models/auth/responses/LoginResponseModel";
import type { CompanyModel } from "models/company/entities/CompanyModel";
import type { PaginatedResponseModel } from "models/shared/PaginatedResponseModel";

export function isLoginResponseModel(response: any): response is LoginResponseModel {
    return response && typeof response.token === 'string';
}

export function isGetCompanyListResponseModel(response: any): response is PaginatedResponseModel<CompanyModel> {
    return (
        response !== null &&
        typeof response === 'object' &&
        Array.isArray(response.content)
    );
}
